import React from "react";
import facebook from "../assets/faceico.ico";
import {NavLink} from "react-router-dom";
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <nav className="footer__map">
          <h3 className="footer__title">Mapa do site</h3>
          <ul className="map-nav">
            <li className="map-nav__item">
              <NavLink className="map-nav__item-link" to="/" exact>Início</NavLink>
            </li>
            <li className="map-nav__item">
              <NavLink className="map-nav__item-link" to="/quem-somos" exact>Quem somos</NavLink>
            </li>
            <li className="map-nav__item">
              <NavLink className="map-nav__item-link" to="/produtos" exact>Produtos</NavLink>
            </li>
            <li className="map-nav__item">
              <NavLink className="map-nav__item-link" to="/servicos" exact>Serviços</NavLink>
            </li>
            <li className="map-nav__item">
              <NavLink className="map-nav__item-link" to="/contato">Contato</NavLink>
            </li>
          </ul>
        </nav>
        <div className="footer__contacts">
          <h3 className="footer__title">Fale conosco</h3>
          <p className="footer__contacts-item">atendimento@saojoseortopedicos.com.br</p>
          <p className="footer__contacts-item">Nova Friburgo: (22) 2523-1535</p>
          <p className="footer__contacts-item">Cabo Frio: (22) 2644-1397</p>
          <p className="footer__contacts-item">Teresópolis: (21) 2742-9932</p>
        </div>
        <div className="footer__social">
          <h3 className="footer__title">Nos acompanhe nas redes sociais</h3>
          <img className="footer__social-image" src={facebook} alt="Facebook"/>
          <svg className="footer__social-image" viewBox="0 0 24 24" fill="currentColor" role="img" aria-label="X">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </div>
      </div>
      <div className="footer__copyright">
        ₢ 2026 São José Ortopédicos
      </div>
    </footer>
  );
}

export default Footer;